const environment = {

    production: process.env.REACT_APP_PRODUCTION === "true",
    apiVirtualCredential: process.env.REACT_APP_API_CREDENCIAL_VIRTUAL,
    apiLogin: {
        endpoint: process.env.REACT_APP_API_LOGIN_ENDPOINT,
        clientId: process.env.REACT_APP_API_LOGIN_CLIENTID,
        grantType: process.env.REACT_APP_API_LOGIN_GRANT_TYPE,
        audience: process.env.REACT_APP_API_LOGIN_AUDIENCE,
        connection: process.env.REACT_APP_API_LOGIN_CONNECTION,
        scope: process.env.REACT_APP_API_LOGIN_SCOPE
    },
    firebaseConfig: {
        apiKey: process.env.REACT_APP_ANALYTICS_APIKEY,
        authDomain: process.env.REACT_APP_ANALYTICS_AUTHDOMAIN,
        projectId: process.env.REACT_APP_ANALYTICS_PROJECTID,
        storageBucket: process.env.REACT_APP_ANALYTICS_STORAGEBUCKET,
        messagingSenderId: process.env.REACT_APP_ANALYTICS_MESSAGINGSENDERID,
        appId: process.env.REACT_APP_ANALYTICS_APPID,
        measurementId: process.env.REACT_APP_ANALYTICS_MEASUREMENTID
    },
    datadogConfig: {
        logs: {
            clientToken: process.env.REACT_APP_DATADOG_LOGS_CLIENT_TOKEN,
            sampleRate: process.env.REACT_APP_DATADOG_LOGS_SAMPLE_RATE,
        },
        rum: {
            clientToken: process.env.REACT_APP_DATADOG_RUM_CLIENT_TOKEN,
            applicationId: process.env.REACT_APP_DATADOG_RUM_CLIENT_APPLICATION_ID,
            sampleRate: process.env.REACT_APP_DATADOG_RUM_SAMPLE_RATE,
            premiumSampleRate: process.env.REACT_APP_DATADOG_RUM_SAMPLE_RATE_PREMIUM,
        }
    },
    versions: {
        android: process.env.REACT_APP_ANDROID_VERSION,
        ios: process.env.REACT_APP_IOS_VERSION,
        web: process.env.REACT_APP_WEB_VERSION,
    }
};

export { environment };